module.exports = __webpack_public_path__ + "static/AM_web_1800x904-7f7153db1e115ca01413912ecec6f6c4.png";